import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'
import ErrorStackParser from 'error-stack-parser'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

export default function UnexpectedErroPage({ error }: { error: Error }) {
  const myError = ErrorStackParser.parse(error)

  return (
    <Box sx={{ display: 'flex', height: '100%', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <Box>
        <Typography align='center' component='h2' variant='h5' >
          Oops! An unexpected error occurred
        </Typography>
        <Typography align='center' component='p' sx={{ mt: 1 }} >
          Reload the page and try again
        </Typography>
        <Typography align='center' component='p' sx={{ mt: 0 }} >
          If the error persists, contact Indrema support
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls='details'
              id='details'
            >
              <Typography>View error details</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Message: {error.message}
              </Typography>
              <Typography>
                {myError.map((e, i) => (
                  <Box key={i}>
                    <Typography>
                      {'  '}  at {e.functionName} - {e.getFileName()} - {e.columnNumber}:{e.lineNumber}
                    </Typography>
                  </Box>
                ))}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Box>
    </Box >
  )
}
